module.exports = __webpack_public_path__ + "img/CY110001.587da660.svg";